import React, { Component } from "react"
export default (props: any) => {

    <>
        {props.children}
    </>
}